import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import { CalendarDays } from "lucide-react";

// Drop-in replacement for <Input type="date">: a button that opens a real
// month-grid calendar picker (shadcn). Stores the value as an ISO date string
// "YYYY-MM-DD" so the rest of the form/serialization is unchanged.
//
// Usage:
//   <DatePickerField value={formData.start_date} onChange={(v) => setFormData({...formData, start_date: v})} />
export default function DatePickerField({ value, onChange, placeholder = "Pick a date", testId = "date-picker", disabled = false, className = "", height = "h-11" }) {
  const selected = value ? new Date(value + "T00:00:00") : undefined;
  const display = value
    ? new Date(value + "T00:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" })
    : placeholder;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          className={`w-full ${height} rounded-md border border-slate-200 bg-white px-3 text-left text-sm flex items-center gap-2 hover:border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#0F4C81]/20 disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
          data-testid={testId}
        >
          <CalendarDays className="w-4 h-4 text-slate-400 flex-shrink-0" />
          <span className={value ? "text-slate-800 truncate" : "text-slate-400 truncate"}>
            {display}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-0 z-[200] max-h-[80vh] overflow-auto"
        align="start"
        sideOffset={4}
        collisionPadding={12}
        avoidCollisions
      >
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => {
            if (!d) { onChange(""); return; }
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            onChange(`${yyyy}-${mm}-${dd}`);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
